import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { LocalStorage } from '../constants/local-storage';
import { AuthenticationData } from '../models/api.models';
import { ConfigService } from './config.service';

@Injectable()
export class LoginService {

  private _loginSuccess$ = new BehaviorSubject<boolean | undefined>(undefined);
  private _accessToken$ = new BehaviorSubject<string | undefined>(undefined);

  constructor(
    private httpClient: HttpClient,
    private configService: ConfigService,
  ) {
    const localAccessToken = localStorage.getItem(LocalStorage.ACCESS_TOKEN);

    if (localAccessToken) {
      this._accessToken$.next(localAccessToken);
    }
  }

  public getLoginSuccess(): Observable<boolean | undefined> {
    return this._loginSuccess$;
  }

  public getAccessToken(): Observable<string | undefined> {
    return this._accessToken$;
  }

  public login(accessToken: string) {
    if(!accessToken){
      this._loginSuccess$.next(false);
    }

    const url = `${this.configService.referencingApiUrl}/api/portal/authenticate`;

    const httpHeaders = new HttpHeaders()
      .set('content-type', 'application/json')
      .set('Access-Control-Allow-Origin', '*')
      .set('AccessToken', accessToken)
      .set('ObfuscatedSiteId', localStorage.getItem(LocalStorage.OBFUSCATED_SITE_ID)!);

    this.httpClient.get<AuthenticationData>(url, { 'headers': httpHeaders }).subscribe({
      next: (result) => {

        if (result.tokenType.length > 0) {
          localStorage.setItem(LocalStorage.ACCESS_TOKEN, accessToken);
          this._accessToken$.next(accessToken);
        } else {
          localStorage.removeItem(LocalStorage.ACCESS_TOKEN);
          this._accessToken$.next(undefined);
        }

        this._loginSuccess$.next(result.tokenType.length > 0);
      },
      error: (error) => {
        if (error.status === 401) {
          this._loginSuccess$.next(false);
          localStorage.removeItem(LocalStorage.ACCESS_TOKEN);
          this._accessToken$.next(undefined);
        } else {
          throw error; // Re-throw the error to handle it further
        }
      }
    })
  }
}
